/* eslint-disable no-unused-vars */
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedModule } from '@sl/shared';

@Component({
  selector: 'sl-sandbox-card',
  templateUrl: './sandbox-card.component.html',
  styleUrls: ['./sandbox-card.component.scss'],
  standalone: true,
  imports: [SharedModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SandboxCardComponent {
  constructor() {}
}
